import React, { useEffect, useState } from "react";
import Loading from "../components/loading";
import Error from "../components/Error";
import { Link, useNavigate } from "react-router-dom";
import MainBg from "../components/Mainbg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/virtual";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { Navigation, A11y } from "swiper/modules";

// ------------------------ Images -----------------------------
import Banner1 from "../assets/images/dasboard/banner1.png";
import Banner2 from "../assets/images/dasboard/banner2.png";
import Banner3 from "../assets/images/dasboard/banner3.png";
import Watchlinked from "../assets/images/dasboard/watchlinked.png";
import MealLogPopup from "../modals/MealLogPopup";
import { useDispatch, useSelector } from "react-redux";
import {
  refreshToken2,
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../store/features/webUtilitiesSlice";
import WaterIntakePopup from "../modals/WaterIntakePopup";
import AppDownloadPopup from "../modals/AppDownloadPopup";
import StartingFasting from "./Fasting/StartFasting";
import FastingInProgress from "./Fasting/FastingInProgress";
import axios from "axios";
import {
  DASHBOARDENDPOINT,
  POST_FASTING_TRACK,
} from "../config/ApisCollection";
import secureLocalStorage from "react-secure-storage";
import EatingInProgress from "./Fasting/EatingInProgress";
import WeightUpdatePopup from "../modals/WeightUpdatePopup";
import BPLogPopup from "../modals/BPLogPopup";
import {
  calculateTimeDifference,
  convertMinutesToHMS,
  convertTo24HourFormat,
  daysOfWeek,
  formatTimestamp,
  LinkedGoogleFit,
} from "../function/functions";
import WaterIntakeSection from "../sections/WaterIntakeSection";
import NutritionSection from "../sections/NutritionSection";

// Today's task color code
const taskColorCode = ["#fd5064", "#5056FD", "#FE7701"];

const Page = () => {
  const [dashboardData, setDashboardData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isfastingTrue, setIsFastingTrue] = useState("default");
  const [isError, setIsError] = useState(false);
  const [errMsg, setErrorMsg] = useState(null);
  const [isMealLogOpen, setIsMealLogOpen] = useState(false);
  const [isWaterIntakeOpen, setIsWaterIntakeOpen] = useState(false);
  const [isWeightUpdateOpen, setIsWeightUpdateOpen] = useState(false);
  const [isBpLogOpen, setBpLogOpen] = useState(false);
  const [isAppDownload, setIsAppDownload] = useState(false);
  const [currentWaterIntakeValue, setCurrentWaterIntakeValue] = useState(6);
  const [currentBPValue, setCurrentBPValue] = useState(null);
  const [currentWeightValue, setCurrentWeightValue] = useState({
    registeredWeight: null,
    latestWeight: null,
    targetWeight: null,
    weightType: null,
  });
  const [numGlass] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
  const [fastingeatingduration, setFastingEatingDuration] = useState(null);
  const accessToken = secureLocalStorage.getItem("accessToken");
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
  const formattedTime = currentDate.toTimeString().split(" ")[0]; // Format time as HH:MM:SS
  const { profileDetails } = useSelector((state) => state.webUtilities);

  // Function to convert 12-hour time format to 24-hour format

  // Get the current day index (0 for Sunday, 1 for Monday, etc.)
  const currentDayIndex = currentDate.getDay();

  // Get the name of the current day
  const currentDayName = daysOfWeek[currentDayIndex];

  const dispatch = useDispatch();
  const history = useNavigate();

  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
    await dispatch(setIsDrawerActive(true));
  };

  const handleDashboardApi = async () => {
    const request_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        CDate: formattedDate,
        CTime: formattedTime,
        "Content-Type": "application/json",
      },
      body: {},
    };

    await axios
      .get(DASHBOARDENDPOINT, request_body)
      .then((response) => {
        if (response) {
          if (
            response.data.fastingsetup &&
            response.data.fastingsetup.length > 0
          ) {
            history("/fasting/setup/plan/", {
              state: response.data.fastingsetup,
            });
            return false;
          } else if (response.data?.responce && response.data.responce.plan) {
            history("/payment-pending/", {
              state: {
                plan: response?.data?.responce?.plan,
                paymentList: response?.data?.responce?.paymentList,
                caseStudy: response?.data?.responce?.summary || null,
              },
            });
            return false;
          } else if (response.data.plan) {
            history("/payment-pending/", {
              state: {
                plan: response?.data?.plan,
                paymentList: response?.data?.paymentList,
                caseStudy: response?.data?.summary || null,
              },
            });
            return false;
          } else {
            setCurrentBPValue(response?.data?.bloodpressurelog);

            let modifyData = response.data;

            modifyData.waterintakeSummary.waterIntakeperDay =
              modifyData.waterintakeSummary.waterIntakeperDay || 6000;
            modifyData.waterintakeSummary.waterIntakeType =
              modifyData.waterintakeSummary.waterIntakeType || "Ml";

            // set weight data
            setCurrentWeightValue(response?.data?.weightSummary);

            // console.log(modifyData);
            setDashboardData(modifyData);

            setCurrentWaterIntakeValue(
              response.data?.waterintakeSummary?.todayTotalWaterintake
            );
            const fastingtrackStatus = response.data.fastingtrack;
            const windowStatus = fastingtrackStatus.type;
            // console.log(response.data.fastingsetupuser);
            // const fastingTime12hr =
            //   response.data.fastingsetupuser[0][currentDayName].endTime12hr;
            const fastingTime12hr =
              response.data.fastingsetupuser.eatingWindowTime.endTime12hr;

            const endTime24hr = convertTo24HourFormat(fastingTime12hr);
            let eatstart12;
            let logTime = null;
            if (response.data.fastingtrack.logTime) {
              eatstart12 = response?.data?.fastingtrack?.logTime;

              logTime = formatTimestamp(eatstart12);
              logTime = convertTo24HourFormat(logTime);
              eatstart12 =
                response.data?.fastingsetupuser?.eatingWindowTime
                  ?.startTime12hr;
            } else {
              eatstart12 =
                response.data?.fastingsetupuser?.eatingWindowTime
                  ?.startTime12hr;
            }

            eatstart12 = convertTo24HourFormat(eatstart12);

            let eatend12 = convertTo24HourFormat(
              response.data?.fastingsetupuser?.eatingWindowTime?.endTime12hr
            );

            // Format current time as HH:MM:SS
            const currentTime24hr = currentDate.toTimeString().split(" ")[0];
            const calculateTypeFor = fastingtrackStatus.activeWindow;
            const isTreatDay = fastingtrackStatus?.isTreatDay == currentDayName;

            // Log time logInMinutes_eating/logInMinutes_fasting
            const logInMinutes_eating =
              response?.data?.fastingstrick?.finalSetDataWithDate
                ?.logInMinutes_eating;
            const logInMinutes_fasting =
              response?.data?.fastingstrick?.finalSetDataWithDate
                ?.logInMinutes_fasting;

            if (calculateTypeFor === "fasting" && !isTreatDay) {
              setIsFastingTrue("fasting");
            } else if (calculateTypeFor === "eating" && !isTreatDay) {
              setIsFastingTrue("eating");
            } else if (isTreatDay) {
              setIsFastingTrue("isTreatDay");
            } else {
              setIsFastingTrue("default");
            }

            const {
              hours,
              minutes,
              seconds,
              completedPercentage,
              eating_hours,
              fasting_hours,
            } = convertMinutesToHMS(
              currentTime24hr,
              endTime24hr,
              eatstart12,
              eatend12,
              logInMinutes_eating,
              logInMinutes_fasting,
              calculateTypeFor,
              windowStatus,
              logTime
            );

            setFastingEatingDuration({
              hours,
              minutes,
              seconds,
              completedPercentage,
              eating_hours,
              fasting_hours,
            });
          }
        }

        // console.log(response);
        setIsLoading(false);
      })
      .catch((error) => {
        if (
          error?.response?.data?.error?.message === "token expired" &&
          secureLocalStorage.getItem("refreshToken")
        ) {
          const refreshed_data = dispatch(refreshToken2());
          // console.log(refreshed_data);
        } else if (error?.response?.data?.error?.message === "token expired") {
          secureLocalStorage.clear();
          history("/login");
        } else if (
          error?.response?.data?.error?.message ===
          "Cannot read property 'country' of null"
        ) {
          alert(
            `This email ID is blocked due to irregular data found. Please ensure you're registered, or try a different email. For assistance, contact support@fastbetter.com.`
          );
          secureLocalStorage.clear();
          history("/login");
        } else {
          setErrorMsg(error?.response?.data?.error?.message);
          setIsError(true);
          setIsLoading(false);
          // console.log(error);
        }
      });
  };

  const postFastingApi = async () => {
    const request_body = {};
    const request_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    try {
      await axios
        .post(POST_FASTING_TRACK, request_body, request_header)
        .then((response) => {
          handleDashboardApi();
          if (response.data.message) {
            toast.error(response.data.message);
          }
        });
    } catch (error) {
      if (
        error?.response?.data?.error?.message === "token expired" &&
        secureLocalStorage.getItem("refreshToken")
      ) {
        dispatch(refreshToken2());
      } else if (error?.response?.data?.error?.message === "token expired") {
        secureLocalStorage.clear();
        history("/login");
      }
    }
  };

  // const handleLinkedDevice = async () => {
  //   try {
  //     const result = await LinkedGoogleFit();
  //     window.location.href = result?.url;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // Update fasting duration by finding setup time
  useEffect(() => {
    // Function to check and reload the page at 4 PM and 6 PM
    const checkTimeForReload = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();

      // console.log(minutes);

      // Check if it's 4:00 PM (16:00) or 6:00 PM (18:00)
      // if ((hours === 12 && minutes === 30) || (hours === 18 && minutes === 0)) {
      if (minutes === 0) {
        // history(0); // Reload the page
        handleDashboardApi();
      }
    };

    // Check every minute if it's time to reload
    const intervalId = setInterval(checkTimeForReload, 60000); // 60000 ms = 1 minute

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    // console.log(accessToken);
    setIsError(false);
    handleDashboardApi();
  }, []);

  // console.log(isLoading);
  if (isLoading) return <Loading />;
  if (isError) return <Error errorMessage={errMsg} />;

  // console.log(Object.entries(dashboardData?.todayMeals));

  return (
    <MainBg>
      {dashboardData ? (
        <>
          {isfastingTrue === "fasting" ? (
            <FastingInProgress
              dashboardData={dashboardData}
              setIsFastingTrue={setIsFastingTrue}
              currentDayName={currentDayName}
              fastingeatingduration={fastingeatingduration}
              postFastingApi={postFastingApi}
            />
          ) : isfastingTrue == "eating" ? (
            <EatingInProgress
              dashboardData={dashboardData}
              setIsFastingTrue={setIsFastingTrue}
              currentDayName={currentDayName}
              fastingeatingduration={fastingeatingduration}
              postFastingApi={postFastingApi}
            />
          ) : isfastingTrue == "isTreatDay" ? (
            <StartingFasting
              dashboardData={dashboardData}
              setIsFastingTrue={null}
              currentDayName={currentDayName}
              fastingeatingduration={fastingeatingduration}
              postFastingApi={null}
            />
          ) : (
            <></>
          )}
          <ToastContainer />
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3">
            <div className="cardbox w-full sm:w-full md:w-full lg:w-full xl:w-full xs:w-full ">
              <div className="mode1">
                <img
                  className="watchImg"
                  alt="watchImg"
                  src={
                    dashboardData?.healthDevice?.status === "active"
                      ? Watchlinked
                      : Banner1
                  }
                />
                {/* Watchlinked */}
                <div className="py-2">
                  <p className="cardboxtitle text-base">
                    {dashboardData?.healthDevice?.status === "active"
                      ? "Your watch is synced"
                      : "Link your device with FastBetter"}{" "}
                  </p>
                  <p className="text-xs">
                    {dashboardData?.healthDevice?.status === "active"
                      ? "health stats are being synced, to change fo to settings."
                      : "Bring a new level of efficiency to your daily tasks. Your"}{" "}
                  </p>
                  <button
                    className="mt-2 light-orgn-btn rounded-lg text-[11px]"
                    onClick={() => {
                      // setIsAppDownload(true);
                      // handleLinkedDevice();
                      handleChangeSidebar(311);
                    }}
                  >
                    {dashboardData?.healthDevice?.status === "active"
                      ? "Want to change, click to unlink"
                      : "Click to link now"}{" "}
                  </button>
                </div>
              </div>
            </div>

            <div className="cardbox w-full sm:w-full md:w-full lg:w-full xl:w-full xs:w-full">
              <div className="mode1">
                <img className="watchImg" alt="watchImg" src={Banner2} />
                <div className="py-2">
                  <p className="cardboxtitle text-base">
                    Any ingredient allergies?
                  </p>
                  <p className="text-xs">
                    Get meals tailored to your needs and preferences.
                  </p>
                  <button
                    className="mt-2 light-orgn-btn rounded-lg text-[11px]"
                    onClick={() => {
                      // setIsAppDownload(true);
                      handleChangeSidebar(319);
                    }}
                  >
                    Update ingredient allergies
                  </button>
                </div>
              </div>
            </div>

            <div
              className="cardbox w-full sm:w-full md:w-full lg:w-full xl:w-full xs:w-full bg-cover bg-center px-0"
              style={{
                backgroundImage: "url('/images/bannerActive.png')",
              }}
            >
              <div className="mode1">
                <img className="watchImg" alt="watchImg" src={Banner3} />
                <div className="py-2">
                  <p className="cardboxtitle text-base">
                    Personalised workouts
                  </p>
                  <p className="text-xs">
                    Plan your workouts focused on the problem areas.
                  </p>
                  <button
                    className="mt-2 light-orgn-btn rounded-lg text-[11px]"
                    onClick={() => {
                      handleChangeSidebar(314);
                    }}
                  >
                    Plan your workouts
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="fasweekdes mt-10">
            <div className="destile1 text-lg font-semibold">
              Your Activities
            </div>
            <div>
              <img
                loading="lazy"
                src="../images/deshboard/backsolid.webp"
                alt="backsolid"
                className="cursor-pointer"
                onClick={handleDashboardApi}
              />
            </div>
          </div>

          <div className="grid grid-cols-1 max-[767px]:grid-cols-2 max-[552px]:grid-cols-1 xs:grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 px-4">
            <div className="acitivbox w-full" style={{ background: "#fde4e3" }}>
              <div className="acitivlerate mb-0">
                <div className="acitivboxtex" style={{ color: "#E91717" }}>
                  {dashboardData?.pulseSummary?.pulse || 0}
                </div>
                <div className="acitivboxuptexbp" style={{ color: "#E91717" }}>
                  {dashboardData?.pulseSummary?.pulseUnit || 0}
                </div>
              </div>
              <div className="acitivbox1" style={{ background: "#f9bcbb" }}>
                <div className="acitivboxicon -md:mt-20 -mt-10 max-[552px]:-mt-5">
                  <img
                    loading="lazy"
                    src="../images/deshboard/heart-beat.png"
                    alt="heartbeat"
                    className="max-[600px]:w-[90px] max-[767px]:w-[108px] w-[82px] md:w-[78px] lg:w-[82px]"
                  />
                </div>
                <div className="acitivboxuptex acitivlerate text-[#E91717] -mt-[10%]">
                  Pulse
                </div>
              </div>
            </div>

            <div className="acitivbox w-full">
              <div className="acitivlerate mb-0">
                <div className="acitivboxtex">
                  {dashboardData?.weightSummary?.latestWeight || 0}
                </div>
                <div className="acitivboxuptexbp">
                  {dashboardData?.weightSummary?.weightType || 0}
                </div>
              </div>
              <div className="acitivbox1">
                <div className="acitivboxicon -md:mt-20 -mt-10 max-[552px]:-mt-5">
                  <img
                    loading="lazy"
                    src="../images/deshboard/weight2.png"
                    alt="weight"
                    className="max-[600px]:w-[90px] max-[767px]:w-[108px] w-[82px] md:w-[78px] lg:w-[82px]"
                  />
                </div>
                <div className="acitivboxuptex acitivlerate  -mt-[10%]">
                  Weight
                </div>
              </div>
            </div>

            <div className="acitivbox w-full" style={{ background: "#e8eff7" }}>
              <div className="acitivlerate mb-0">
                <div className="acitivboxtex" style={{ color: "#197bd2" }}>
                  {dashboardData?.stepSummary?.todayTotalSteptrake || 0}
                </div>
                <div className="acitivboxuptexbp" style={{ color: "#197bd2" }}>
                  {"steps"}
                </div>
              </div>

              <div className="acitivbox1" style={{ background: "#bfd8f0" }}>
                <div className="acitivboxicon -md:mt-20 -mt-10 max-[552px]:-mt-5">
                  <img
                    loading="lazy"
                    src="../images/deshboard/arrow1.png"
                    alt="arrow"
                    className="max-[600px]:w-[90px] max-[767px]:w-[108px] w-[82px] md:w-[78px] lg:w-[82px]"
                  />
                </div>
                <div className="acitivboxuptex acitivlerate text-[#197bd2] -mt-[10%]">
                  Walk
                </div>
              </div>
            </div>

            <div className="acitivbox w-full" style={{ background: "#f1eaf6" }}>
              <div className="acitivlerate mb-0">
                <div className="acitivboxtex" style={{ color: "#7042c9" }}>
                  {Math.round(
                    dashboardData?.workoutSummary?.totalPlayTime / 60
                  ) || 0}
                </div>
                <div className="acitivboxuptexbp" style={{ color: "#7042c9" }}>
                  {/* {dashboardData?.workoutSummary?.unit || "min"} */}
                  {"min"}
                </div>
              </div>

              <div className="acitivbox1" style={{ background: "#d7c9ed" }}>
                <div className="acitivboxicon -md:mt-20 -mt-10 max-[552px]:-mt-5">
                  <img
                    loading="lazy"
                    src="../images/deshboard/handgrip1.png"
                    alt="handgrip"
                    className="max-[600px]:w-[90px] max-[767px]:w-[108px] w-[82px] md:w-[78px] lg:w-[82px]"
                  />
                </div>
                <div className="acitivboxuptex acitivlerate text-[#7042c9] -mt-[10%]">
                  Workout
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1  sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-5  mt-10 mb-10">
            <NutritionSection
              nutritionData={dashboardData?.todayNutrientsTargets}
              pageName={"dashboard"}
              setIsMealLogOpen={
                Object.entries(dashboardData?.todayMeals).length > 0
                  ? setIsMealLogOpen
                  : null
              }
            />

            <WaterIntakeSection
              waterData={dashboardData?.waterintakeSummary}
              numGlass={numGlass}
              setIsWaterIntakeOpen={setIsWaterIntakeOpen}
            />

            <div className="sm:w-full md:w-full w-full">
              <div className="fasweekdes">
                <div className="mode1">
                  <div className="tabroe">
                    <div className="modetit text-lg">Today’s tasks</div>
                    <div className="modesutit text-[11px]">
                      Complete the listed tasks
                    </div>
                  </div>
                </div>
              </div>

              <div className="fasweekdes ">
                {/* {console.log(dashboardData?.today_task)} */}
                {Object.entries(dashboardData?.today_task).length > 0 &&
                  Object.entries(dashboardData?.today_task).map(
                    (task_row, index) => {
                      return (
                        <div
                          className="melasbox cursor-pointer"
                          onClick={() => {
                            if (task_row[1]?.txt === "Measure Weight") {
                              setIsWeightUpdateOpen(true);
                            } else if (task_row[1]?.txt === "Blood Pressure") {
                              setBpLogOpen(true);
                            } else if (task_row[1]?.txt === "Your Mood") {
                              handleChangeSidebar(6);
                            }
                          }}
                          key={index}
                        >
                          <div>
                            <img
                              loading="lazy"
                              src={task_row[1]?.img}
                              alt={task_row[1]?.txt}
                              className="mealsimg"
                            />
                          </div>
                          <div
                            className="todaytasks"
                            style={{ background: taskColorCode[index] }}
                          >
                            {task_row[1]?.txt}
                          </div>
                        </div>
                      );
                    }
                  )}

                {/* <div
                  className="melasbox cursor-pointer"
                  onClick={() => {
                    setBpLogOpen(true);
                  }}
                >
                  <div>
                    <img
                      loading="lazy"
                      src="../images/deshboard/Bloodpressure.webp"
                      alt="meals1"
                      className="mealsimg"
                    />
                  </div>
                  <div className="todaytasks" style={{ background: "" }}>
                    Blood pressure
                  </div>
                </div>
                <div
                  className="melasbox cursor-pointer"
                  onClick={() => {
                    handleChangeSidebar(6);
                  }}
                >
                  <div>
                    <img
                      loading="lazy"
                      src={
                        dashboardData?.moodSummary != null &&
                        dashboardData?.moodSummary != undefined &&
                        dashboardData?.moodSummary.imgUrl
                          ? dashboardData?.moodSummary.imgUrl
                          : "../images/deshboard/Yourmood.webp"
                      }
                      alt="meals1"
                      className="mealsimg"
                    />
                  </div>
                  <div
                    className="todaytasks text-capitalize"
                    style={{ background: "" }}
                  >
                    {dashboardData?.moodSummary != null &&
                    dashboardData?.moodSummary != undefined &&
                    dashboardData?.moodSummary.imgUrl
                      ? dashboardData?.moodSummary?.title
                      : "Your mood"}
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          <div
            className={`meals ${
              Object.entries(dashboardData?.todayMeals).length > 0
                ? ""
                : "hidden"
            }`}
          >
            <div className="fasweekdes">
              <Link to="/mealdiet">
                <div className="destile1 spacetop1">Recommended Meals</div>
              </Link>

              <div className="spacetop1">
                <Link to="/mealdiet">
                  <img
                    loading="lazy"
                    src="../images/deshboard/chevron.webp"
                    alt="chevron"
                  />
                </Link>
              </div>
            </div>

            <div className="fasweekdes mb-20">
              <Swiper
                // install Swiper modules
                modules={[Navigation, Pagination, A11y]}
                spaceBetween={20}
                slidesPerView={4}
                autoplay={true}
                breakpoints={{
                  0: {
                    slidesPerView: 1.5,
                  },
                  400: {
                    slidesPerView: 2.5,
                  },
                  639: {
                    slidesPerView: 3.5,
                  },
                  865: {
                    slidesPerView: 3.5,
                  },
                  1000: {
                    slidesPerView: 5,
                  },
                  1500: {
                    slidesPerView: 5,
                  },
                  1700: {
                    slidesPerView: 5,
                  },
                }}
                navigation
                effect="fade"
                pagination={{ clickable: true }}
              >
                {dashboardData?.todayMeals !== null &&
                  Object.entries(dashboardData?.todayMeals).length > 0 &&
                  Object.entries(dashboardData?.todayMeals)?.map(
                    (meal_row, index) => (
                      <SwiperSlide key={index}>
                        <div
                          className="melasbox cursor-pointer w-[230px]"
                          onClick={() => {
                            history("/mealdiet/meal-view", {
                              state: meal_row[1][0],
                            });
                          }}
                        >
                          <div>
                            <img
                              loading="lazy"
                              src={meal_row[1][0]?.thumbnail}
                              alt="meals1"
                              className="mealsimg h-[150px] w-[250px]"
                            />
                          </div>
                          <div className="melalin">
                            <div className="modesutit text-capitalize">
                              {meal_row[1][0]?.dietFrequency?.replace("_", " ")}
                            </div>
                            <div className="tabetsbol text-capitalize eat-box-text-limit">
                              {meal_row[1][0]?.dietTitle?.slice(0, 25)}...
                            </div>
                            <hr />
                            <div className="fastiweekboxtit">
                              {meal_row[1][0]?.dietCal} cal
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    )
                  )}
              </Swiper>
            </div>
          </div>
        </>
      ) : (
        <Loading />
      )}
      <MealLogPopup
        isMealLogOpen={isMealLogOpen}
        setIsMealLogOpen={setIsMealLogOpen}
        handleDashboardApi={handleDashboardApi}
      />
      <WaterIntakePopup
        isWaterIntakeOpen={isWaterIntakeOpen}
        setIsWaterIntakeOpen={setIsWaterIntakeOpen}
        currentWaterValue={currentWaterIntakeValue}
        handleDashboardApi={handleDashboardApi}
        waterintakeSummary={dashboardData?.waterintakeSummary}
      />

      <WeightUpdatePopup
        isWeightUpdateOpen={isWeightUpdateOpen}
        setIsWeightUpdateOpen={setIsWeightUpdateOpen}
        currentWeightValue={currentWeightValue}
        handleDashboardApi={handleDashboardApi}
      />
      <BPLogPopup
        isBpLogOpen={isBpLogOpen}
        setBpLogOpen={setBpLogOpen}
        currentBPValue={currentBPValue}
        handleDashboardApi={handleDashboardApi}
      />

      <AppDownloadPopup
        isAppDownload={isAppDownload}
        setIsAppDownload={setIsAppDownload}
      />
    </MainBg>
  );
};
export default Page;
